import script from "./editRuleModal.vue?vue&type=script&setup=true&lang=js"
export * from "./editRuleModal.vue?vue&type=script&setup=true&lang=js"

import "./editRuleModal.vue?vue&type=style&index=0&id=125c21a5&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-125c21a5"]])

export default __exports__